import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { MapaToolsComponent } from '../mapa-tools/mapa-tools';
import { Constant } from '../../constant';
import { ListaMovilesService } from '../../services/lista-moviles.service';
import { MapToolsService } from '../../services/map-tools.service';
import { RutasService } from '../../services/rutas-service/rutas.service';
import { mapIcon } from '../../mapa/mapa-tools/mapa-icons';
import { MapsAPILoader } from '@agm/core';
import { Gtp } from '../../gtp';
import { Observable, of } from 'rxjs';
import { PuntoCliente } from 'src/app/models/punto-cliente.model';
import { PuntosService } from '../../services/puntos-service/puntos.service';
import { ConfirmDialog } from '../../confirmdialog/confirmdialog.component';
import Swal from 'sweetalert2';
import { ListaGeocerca } from 'src/app/models/mapa-geocerca';
import { Ruta } from 'src/app/models/ruta.model';
import { zIndex } from 'html2canvas/dist/types/css/property-descriptors/z-index';
declare const google: any;

@Component({
  selector: 'app-mapa-full',
  templateUrl: './mapa-full.component.html',
  styleUrls: ['./mapa-full.component.scss']
})
export class MapaFullComponent extends MapaToolsComponent implements OnInit {

  @ViewChild('AgmMap', { static: false }) agm;
  showPolyline:boolean = false;
  intervalMinFLota: number = 1;
  tiempoInterval: any = false;
  minClusterSize = 50;
  currentZoomLevel: number = 0;
  vehicleLabelMinZoom: number = 11;
  boundsChangeTimeout: any = null;
  esperandoMarcadoresRecorrido: boolean = false; // A partir de cuantos markers hace el cluster
  resumenRecorrido: any = false;
  resumenListado: any = false;
  resumenEventos: any = false;
  posRecorridoActivo:number;
  canClickMap:boolean = false;

  canClickPuntos:boolean = false;
  canClickGeocercas:boolean = false;
  canClickGeocercasCircular:boolean = false;
  canClickRutas:boolean = false;
  seleccionRutasActiva:boolean = false;

  // Nuevas propiedades
  heatmapData: any[] = [];
  heatmapVisible: boolean = false;
  terrainVisible: boolean = false;
  currentMapType: string = 'roadmap';

  // Propiedades para medición
  medicionDistanciaActiva: boolean = false;
  medicionAreaActiva: boolean = false;
  puntosMedicion: any[] = [];
  distanciaMedida: number = 0;
  areaMedida: number = 0;

  // Propiedades para formas predefinidas
  formaActual: string = 'libre'; // 'libre', 'cuadrado', 'rectangulo', 'circulo', 'hexagono'
  centroForma: any = null;
  radioForma: number = 100; // radio en metros

  geocercas = []; // Polygonos
  rutasUsuario: Ruta[] = []; // Rutas del usuario
  puntosTemporalesRuta: any[] = []; // Puntos temporales para rutas en creación
  public paths: Array<any[]> = [];
  marcadores = [];
  previous;
  //RADIO DE UNA UBICACION
  lat_radio: number = 0;
  lng_radio: number = 0;

  g = {
    isOpen: true,
    lat: null,
    lng: null,
    cod_geocerca: null,
    des_geocerca: '',
    puntos: null,
  }

  rightSidebar:boolean = false;
  dialog: any;

  //RUTAS
  public rutas = {
    origin: {},
    destination: {}
  }
  public origin: any;
  public destination: any;

  // Nuevas propiedades para manejar la redimensión
  poligonoEditable: boolean = true;
  ultimaAreaCalculada: number = 0;

  // Propiedad para almacenar referencia al polígono
  poligonoActual: any = null;

  intervaloActualizacionPoligono: any = null;

  // Variable para almacenar el polígono de Google Maps nativo
  poligonoGoogleMaps: any = null;

  // Propiedades para versión
  get appVersion(): string {
    return this.constant.version;
  }

  get appVersionDate(): string {
    return this.constant.fechaUltAct;
  }

  // Hacer Math disponible en el template
  Math = Math;

  /**
   * Obtiene el icono SVG para los puntos de ruta en modo selección-mapa
   */
  getIconoPuntoRutaSeleccion(): string {
    const svg = '<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20"><circle cx="10" cy="10" r="8" fill="#4CAF50" stroke="white" stroke-width="2"/></svg>';
    return 'data:image/svg+xml;charset=UTF-8,' + encodeURIComponent(svg);
  }

  /**
   * Obtiene el icono de círculo verde para el origen de la ruta
   */
  getIconoOrigenRuta(): string {
    const svg = '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><circle cx="12" cy="12" r="10" fill="#4CAF50" stroke="white" stroke-width="3"/></svg>';
    return 'data:image/svg+xml;charset=UTF-8,' + encodeURIComponent(svg);
  }

  /**
   * Obtiene el icono de círculo rojo para el destino de la ruta
   */
  getIconoDestinoRuta(): string {
    const svg = '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><circle cx="12" cy="12" r="10" fill="#F44336" stroke="white" stroke-width="3"/></svg>';
    return 'data:image/svg+xml;charset=UTF-8,' + encodeURIComponent(svg);
  }

  constructor(
    public constant: Constant,
    public gtp: Gtp,
    public listamovilesservice: ListaMovilesService,
    public puntosService: PuntosService,
    private mapsAPILoader: MapsAPILoader,
    private MapToolsService: MapToolsService,
    private rutasService: RutasService,
    private mapIcon: mapIcon
  ) {
    super();
    this.initMap();
    this.currentZoomLevel = this.mapConfig?.zoom || 15;
  }

  onMapZoomChange(zoom: number) {
    this.currentZoomLevel = zoom;
    this.mapConfig.zoom = zoom;
    if (this.tipoMapa?.verflota) {
      this.updateMarkers();
    }
  }

  getMarkerLabel(punto: any): string | null {
    if (!punto || punto.isCluster || this.currentZoomLevel < this.vehicleLabelMinZoom) {
      return null;
    }

    // Evitamos des_equipo_ratreo porque suele traer nombre de empresa.
    const nombreMovil = (punto.label || punto.nombre || '').toString().trim();
    const descripcionMovil = (punto.des_equipo_ratreo || '').toString().trim();
    const matricula = (punto.matricula || '').toString().trim();
    const nroVehiculo = (punto.nro_vehiculo || '').toString().trim();
    const codigo = (punto.cod_equipo_rastreo || '').toString().trim();
    const esValorValido = (valor: string): boolean => {
      const normalizado = (valor || '').toString().trim();
      const upper = normalizado.toUpperCase();
      return normalizado !== '' && upper !== 'PROVISORIO' && upper !== 'NULL';
    };

    // OPCION 1 (activa): Nombre movil + matricula.
    if (esValorValido(nombreMovil)) { return nombreMovil; }
    if (esValorValido(matricula)) {
      return matricula;
    }

    // OPCION 2: Nombre + numero de vehiculo.
    // if (nombreMovil && nroVehiculo) { return `${nombreMovil} ${nroVehiculo}`.trim(); }
    // if (nombreMovil) { return nombreMovil; }

    // OPCION 3: Nombre + codigo de equipo.
    // if (nombreMovil && codigo) { return `${nombreMovil} ${codigo}`.trim(); }
    // if (nombreMovil) { return nombreMovil; }

    const fallback = [descripcionMovil].find((valor) => esValorValido(valor));
    if (fallback) { return fallback; }

    return (punto.label || '').toString().trim() || null;
  }

  updateMarkers() {
    if (this.tipoMapa?.verflota) {
      const build = (source: any[]) => {
        this.markers = this.buildFleetClusters(source || []);
        if (this.centerMapMakerUpdate){
          this.disableCenterMapMakerUpdate();
        }
      };

      if(!this.agm){
        build(this.allMarkers);
        return;
      }

      this.agm._mapsWrapper.getBounds().then(newBounds => {
        const inBounds = (this.allMarkers || []).filter((marker) => {
          if (marker?.visible === false) { return false; }
          if (!newBounds) { return true; }
          return newBounds.contains(new google.maps.LatLng(marker.latitud, marker.longitud));
        });
        build(inBounds);
      });
      return;
    }

    super.updateMarkers();
  }

  private buildFleetClusters(source: any[]): any[] {
    const zoom = this.currentZoomLevel || this.mapConfig?.zoom || 15;
    const radius = this.getClusterRadiusMeters(zoom);
    if (!source?.length || radius <= 0) {
      return source;
    }

    const clusters: any[] = [];
    source.forEach((marker) => {
      if (!marker || marker.visible === false) { return; }
      const lat = Number(marker.latitud);
      const lng = Number(marker.longitud);
      if (isNaN(lat) || isNaN(lng)) { return; }

      let target = null;
      for (const cluster of clusters) {
        const dist = this.distanceMeters(lat, lng, cluster.lat, cluster.lng);
        if (dist <= radius) {
          target = cluster;
          break;
        }
      }

      if (!target) {
        clusters.push({ lat, lng, members: [marker] });
        return;
      }

      target.members.push(marker);
      const total = target.members.length;
      target.lat = ((target.lat * (total - 1)) + lat) / total;
      target.lng = ((target.lng * (total - 1)) + lng) / total;
    });

    const render: any[] = [];
    clusters.forEach((cluster, i) => {
      if (cluster.members.length === 1) {
        render.push(cluster.members[0]);
        return;
      }

      const count = cluster.members.length;
      render.push({
        id: `cluster-${i}-${count}`,
        isCluster: true,
        clusterCount: count,
        latitud: cluster.lat,
        longitud: cluster.lng,
        icono: this.buildClusterIcon(count),
        openinfo: false
      });
    });

    return render;
  }

  private getClusterRadiusMeters(zoom: number): number {
    // Ajuste: agrupar antes al alejar para evitar encimado de vehiculos.
    if (zoom >= 20) { return 0; }
    if (zoom >= 19) { return 12; }
    if (zoom >= 18) { return 22; }
    if (zoom >= 17) { return 36; }
    if (zoom >= 16) { return 60; }
    if (zoom >= 15) { return 110; }
    if (zoom >= 14) { return 180; }
    if (zoom >= 13) { return 420; }
    if (zoom >= 12) { return 700; }
    if (zoom >= 11) { return 1300; }
    if (zoom >= 10) { return 2300; }
    if (zoom >= 9) { return 3600; }
    if (zoom >= 8) { return 5600; }
    if (zoom >= 7) { return 8200; }
    if (zoom >= 6) { return 11500; }
    return 15500;
  }

  private distanceMeters(lat1: number, lng1: number, lat2: number, lng2: number): number {
    const R = 6371000;
    const dLat = (lat2 - lat1) * Math.PI / 180;
    const dLng = (lng2 - lng1) * Math.PI / 180;
    const a =
      Math.sin(dLat / 2) * Math.sin(dLat / 2) +
      Math.cos(lat1 * Math.PI / 180) * Math.cos(lat2 * Math.PI / 180) *
      Math.sin(dLng / 2) * Math.sin(dLng / 2);
    const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
    return R * c;
  }

  private buildClusterIcon(count: number): string {
    const size = 56;
    const color = count >= 20 ? '#f4b400' : '#2f80ed';
    const ring = count >= 20 ? '#ffd666' : '#8ec5ff';
    const svg = `
      <svg xmlns="http://www.w3.org/2000/svg" width="${size}" height="${size}" viewBox="0 0 56 56">
        <circle cx="28" cy="28" r="23" fill="${ring}" fill-opacity="0.55"/>
        <circle cx="28" cy="28" r="18" fill="${color}"/>
        <text x="28" y="33" text-anchor="middle" font-size="16" font-family="Arial" font-weight="bold" fill="#111">${count}</text>
      </svg>
    `;
    return 'data:image/svg+xml;charset=UTF-8,' + encodeURIComponent(svg);
  }

  trackByMarker(index: number, punto: any): string {
    return String(punto?.id || punto?.cod_equipo_rastreo || `${index}-${punto?.latitud}-${punto?.longitud}`);
  }

  trackByPuntoCliente(index: number, punto: any): string {
    return String(punto?.id || `${index}-${punto?.latitud}-${punto?.longitud}`);
  }

  ngOnDestroy() {
    clearInterval(this.tiempoInterval);
    this.detenerMonitoreoPoligono();
  }

  ngOnInit() {
    this.mapsAPILoader.load().then(() => {
      this.showTipoMapa();
      this.getMapMarkers(); //Marcadores Vehiculos
      this.getCenterMap();
      this.getdisplayMarker();
      this.getMapGeocercas();
      this.getMapRutas();
      this.getZoomMap();
      this.showTraffic();
      this.cargarGeocercas();
      this.cargarPuntos();
      this.getResumenRecorrido();
      this.cleanMapMarkers();
      this.setControlPuntos();
      this.getPuntosClienteMarkers();
      this.getIconServer();
      // Nuevos listener para funcionalidades
      this.listenForMapType();
      this.listenForHeatmap();
      this.listenForTerrain();
      this.listenForMedicionDistancia();
      this.listenForMedicionArea();
      this.listenForSeleccionRutas();
      this.listenForPuntosTemporalesRuta();

      // Iniciar monitoreo de cambios en el polígono
      this.iniciarMonitoreoPoligono();

      // Configurar posición de los controles del mapa
      this.configurarControlesMapa();
    });
    //this.getDirection();
  }

  getDirection() {
    //this.origin = { lat: -25.318879107604573, lng: -57.50212480488403 };
    //this.destination = { lat: -25.46695943800686, lng:  -56.45160233823486 };

    // Location within a string
     this.origin = 'UniNorte Facultad de Medicina';
     this.destination = 'Paseo La Galería';
  }

  toggleRightSidebar(){
    let state = (this.rightSidebar) ? false : true;
    this.gtp.rightSidebarOpened = state;
    this.gtp.setRightSidebar({
      open: state,
      component: false
    })
  }

  /**
   * Trae los datos del resumen de recorrido
   */
  getResumenRecorrido(){
    this.listamovilesservice.getResumenRecorrido().subscribe(data => {
      //console.log(data)
      this.resumenRecorrido = data.resumen;
      this.resumenListado = data.recorrido;
      this.resumenEventos = data.eventos;
    });
    this.listamovilesservice.getPositionRecorrido().subscribe(pos => {
      if(this.posRecorridoActivo) {
        this.allMarkers[this.posRecorridoActivo].openinfo = false;
      }
      this.allMarkers[pos.markerpos].openinfo = true;
      //console.log(pos.markerpos)
      if (pos.markerpos==0){
        this.centerMap({ latitud: pos.latitud, longitud: pos.longitud });
       } else {
        this.mapCenterMarker(pos.markerpos);
      }
      this.setZoom(20);
      this.posRecorridoActivo = pos.markerpos;
    });
  }

  /**
   * Trae los marcadores del API
   */
  getMapMarkers(){
    this.listamovilesservice.getMarkers().subscribe(data => {
      //console.log(data)
      clearInterval(this.tiempoInterval);
      const markerSource = Array.isArray(data) && data.length ? data[0].markerSource : null;

      this.resumenRecorrido = false;
      if (this.tipoMapa.recorrido) {
        // Si llega un paquete de flota durante recorrido (race de peticiones), ignorarlo.
        if (Array.isArray(data) && data.length && markerSource !== 'recorrido') { return; }
        this.allMarkers = data;
        this.mapCenterMarker( (this.allMarkers.length - 1).toString() );
        this.setZoom(16);
        //this.updateMarkers();
      } else {
        // Si llega un paquete de recorrido cuando estamos en flota, ignorarlo.
        if (Array.isArray(data) && data.length && markerSource !== 'flota') { return; }
        this.allMarkers = data;
        if (this.centerMapMakerUpdate){
          this.mapCenterMarker();
        }
        this.updateFlota(); // Actualizar mapa cada 1 minuto
      }
      this.updateMarkers();
    });
  }

  /**
   * traer las geocercas del cliente
   */
  getMapGeocercas(){
    this.MapToolsService.callGeocercas();
    this.MapToolsService.getGeocercasObs().subscribe(res => {
      let geocercas = [];
      res.forEach(el => { if (el.visible) {
        //console.log(el)
        geocercas.push(el);
      }
    });
    this.geocercas = geocercas;
    });
  }

  /**
   * traer las rutas del usuario
   * Ahora también se suscribe a la ruta temporal (vista previa) y la muestra junto con las rutas del usuario.
   */
  getMapRutas(){
    // Variable local para mantener la ruta temporal entre callbacks
    let rutaTemp: Ruta = null;

    // Suscripción a las rutas del usuario
    this.rutasService.getRutasObs().subscribe(res => {
      let rutasVisibles: Ruta[] = [];
      res.forEach(ruta => {
        if (ruta.visible) {
          rutasVisibles.push(ruta);
        }
      });

      // Si existe una ruta temporal vigente, agregarla (si no está ya presente)
      if (rutaTemp) {
        const existe = rutasVisibles.find(r => r.nombre === rutaTemp.nombre);
        if (!existe) {
          rutasVisibles = [...rutasVisibles, rutaTemp];
        } else {
          // Reemplazar la entrada existente por la versión temporal actualizada
          rutasVisibles = rutasVisibles.map(r => r.nombre === rutaTemp.nombre ? rutaTemp : r);
        }
      }

      this.rutasUsuario = rutasVisibles;
    });

    // Suscribirse a la ruta temporal (vista previa)
    this.rutasService.getRutaTemporalObs().subscribe(rutaTemporal => {
      rutaTemp = rutaTemporal;
      if (rutaTemporal) {
        console.log('🗺️ MAPA: Recibida ruta temporal:', rutaTemporal);
        console.log('📍 MAPA: Puntos intermedios:', rutaTemporal.puntosIntermedios);
        console.log('📊 MAPA: Cantidad de waypoints:', rutaTemporal.puntosIntermedios?.length || 0);

        // Agregar la ruta temporal a la lista para mostrarla en el mapa si no está ya incluida
        const ya = (this.rutasUsuario || []).find(r => r.nombre === rutaTemporal.nombre);
        if (!ya) {
          this.rutasUsuario = [...(this.rutasUsuario || []), rutaTemporal];
        } else {
          // Reemplazar la existente por la temporal actualizada
          this.rutasUsuario = (this.rutasUsuario || []).map(r => r.nombre === rutaTemporal.nombre ? rutaTemporal : r);
        }

        console.log('✅ MAPA: rutasUsuario actualizado:', this.rutasUsuario);
      } else {
        // Remover la ruta temporal si existe (usando nombre 'Vista Previa' como referencia)
        this.rutasUsuario = (this.rutasUsuario || []).filter(r => r.nombre !== 'Vista Previa');
      }
    });
  }

  /**
   * Cambias el tipo de mapa a mostrar. Ej: Recorrido, flota
   */
  showTipoMapa(){
    this.MapToolsService.getObsTipoMapa().subscribe(data => {
      this.tipoMapa = data;
      if (data.recorrido){
        this.esperandoMarcadoresRecorrido = true;
        // Limpiar datos de flota inmediatamente para que el cluster quede vacío y el template de recorrido no muestre íconos de flota
        this.allMarkers = [];
        this.markers = [];
      } else {
        this.esperandoMarcadoresRecorrido = false;
        // Limpiar marcadores del recorrido anterior antes de activar el cluster de flota
        this.allMarkers = [];
        this.markers = [];
        this.updateMarkers();
      }

      //console.log('data.recorrido', data);
      //recorrido: false, verflota: true,
      /* if (data.recorrido && !data.verflota){
        this.mapCenterMarker( (this.allMarkers.length-1).toString() );
      }
      if (!data.recorrido && data.verflota) {
        this.updateMarkers();
      }  */
    });
  }

  /**
   * Escucha para cambio de zoom del mapa
   */
  getZoomMap(){
    this.MapToolsService.getZoomMapaObs().subscribe(zoom => {
      this.setZoom(zoom);
    });
  }

  /**
   * Escucha para cambio del centro del mapa
   */
  getCenterMap() {
    this.MapToolsService.getObsCenterMapa().subscribe(newpos => {
      this.centerMap(newpos);
    });
  }

  /**
   * Escucha para ver que marcadores mostrar
   */
  getdisplayMarker(){
    this.MapToolsService.getObsDisplayMarker().subscribe(state => {
      this.displayMarker(state);
    });
  }

  /**
   * Intervalo para actualizar la flota de móviles
   */
  updateFlota() {
    this.tiempoInterval = setInterval(() => {
      this.listamovilesservice.callflotaMoviles();
    }, ((this.intervalMinFLota * 60) * 1000));
  }

  cleanMapMarkers(){
    this.listamovilesservice.getUpdateMarkers().subscribe(data => {
      this.updateMarkers();
    });
  }

  /**
   * Muestra / Oculta datos de tráfico
   */
  showTraffic(){
    this.MapToolsService.getTrafficObs().subscribe(res => {
      this.trafficLayer.setMap((res) ? this.map : null);
    });
    setTimeout(() => {
      this.MapToolsService.setTrafficObs(true);
    }, 100);
  }
  cargarGeocercas(){
    this.MapToolsService.getCargaGeocercaObs().subscribe(res => {
      //console.log(res)
      if (this.canClickPuntos) {
        this.canClickGeocercas = res
      } else {
        this.MapToolsService.cargaPuntos = true;
        this.canClickPuntos = true
        this.canClickGeocercas = res
      }
    });
  }
   cargarPuntos(){
    this.MapToolsService.getCargaPuntosObs().subscribe(res => {
      //console.log(res)
      this.canClickPuntos = res

    });
  }
  ngAfterContentInit(){

  }

  // Inserta en un Array los puntos seleccionados
  setControlPuntos(){
    this.MapToolsService.getPuntoMapObs().subscribe(res => {
      //console.log(res);
      this.puntosCliente.push(res);
    });
  }

  /**
   * Ha realizado un click en el mapa
   * @param ev Evento del mapa clickeado
   */
  mapClick(ev){
    // Si está en modo selección de rutas
    if (this.seleccionRutasActiva) {
      const punto = {
        lat: ev.coords.lat,
        lng: ev.coords.lng
      };
      this.MapToolsService.setPuntoRutaSeleccionado(punto);
      return;
    }

    // Si está en modo medición de distancia o área
    if (this.medicionDistanciaActiva || this.medicionAreaActiva) {
      const punto = {
        lat: ev.coords.lat,
        lng: ev.coords.lng
      };

      // Crear efecto visual en el punto de clic
      this.crearEfectoClick(ev.coords.lat, ev.coords.lng);

      // Medición (distancia o área)
      this.puntosMedicion.push(punto);

      // Cálculo de distancia
      if (this.medicionDistanciaActiva && this.puntosMedicion.length > 1) {
        const ultimoPunto = this.puntosMedicion[this.puntosMedicion.length - 2];
        const distancia = this.calcularDistancia(
          ultimoPunto.lat, ultimoPunto.lng,
          punto.lat, punto.lng
        );
        this.distanciaMedida += distancia;
      }

      // Cálculo de área para formas libres
      if (this.medicionAreaActiva && this.puntosMedicion.length >= 3) {
        // Crear una copia temporal de los puntos para calcular el área
        const puntosTemporal = [...this.puntosMedicion];

        // Para el cálculo, cerramos temporalmente el polígono si no está cerrado
        const primerPunto = puntosTemporal[0];
        const ultimoPunto = puntosTemporal[puntosTemporal.length - 1];

        if (primerPunto.lat !== ultimoPunto.lat || primerPunto.lng !== ultimoPunto.lng) {
          puntosTemporal.push({...primerPunto});
        }

        // Calcular área sin cerrar realmente el polígono
        this.areaMedida = this.calcularArea(puntosTemporal);
        this.ultimaAreaCalculada = this.areaMedida;

        // Si tenemos 3 o más puntos, crear el polígono editable nativo
        if (this.puntosMedicion.length >= 3) {
          this.crearPoligonoAvanzado();
        }
      }

      return;
    }

    // Comportamiento original del mapClick
    let icon = this.mapIcon.getIcon('punto', 'rojo', parseFloat('0'));
    if (this.canClickPuntos){
      let marker = {
        icono: icon,
        latitud: ev.coords.lat,
        longitud: ev.coords.lng,
        draggable: true,
        openinfo: (this.puntosCliente.length >=1) ? false:true
      };
      //console.log(marker);
      this.MapToolsService.setPuntoMapObs(marker);
    }

    if(this.canClickGeocercas){
      if (this.puntosCliente.length >=1) {
        if (this.paths.length > 0) {
          console.log('No puede crear mas de una geocerca a la vez')
        }else{
          this.marcadores.push({lat: ev.coords.lat, lng: ev.coords.lng});
          //console.log(this.puntosCliente)
          //console.log(this.marcadores)
        }
      }
    }

    if(this.canClickGeocercasCircular){
      this.lat_radio =  ev.coords.lat
      this.lng_radio = ev.coords.lng
    }
  }

  getIconServer(){
    let iconsServer = []
    this.puntosService.getIconos().subscribe(res => {
      iconsServer.push(res);
    })
    this.iconServer = iconsServer
  }

  /**
   * Trae los marcadores del API
   */
  getPuntosClienteMarkers() {

    this.puntosService.getPuntosClienteObs().subscribe(data => {
      let arrPuntosClie = []
      //console.log(data)
      data.map((ev, i)=>{
        //let icon = this.mapIcon.getIcon('punto', 'naranja', parseFloat('0'));
        let icon = ''
        this.iconServer.forEach((data, i) => {
            //console.log(ev.icono)
            //console.log(data)
            data.forEach((el, i) => {
              if (el.full_path == 'gtpmovil.com/apirastreo/v1/static/'+ev.icono) {
                  //console.log(el.full_path)
                  icon = 'https://'+el.full_path
              }
            })
        });

        let marker = {
          cod_cliente:ev.cod_cliente,
          gid:ev.gid,
          nombre:ev.nombre,
          tipo_punto:ev.tipo_punto,
          tipo_punto_id:ev.tipo_punto_id,
          icono: icon,
          radio:ev.radio,
          //icono_url:ev.icono,
          checked:ev.checked,
          latitud: ev.latitud,
          longitud: ev.longitud,
          openinfo: (i==0)?true:false
        };
        arrPuntosClie.push(marker);
      })
      //console.log(arrPuntosClie)

      this.allPuntosCliente = arrPuntosClie
      this.puntosCliente = arrPuntosClie
      //this.updatePuntosClienteMarkers();
    });
  }


  /**
   * MARKERS
   */
  eliminarMarker(i, punto) {
    if (punto.gid) {
      console.log('Aca no sucedio nada')
    }else{
      this.puntosCliente.splice(i, 1);
      this.marcadores.splice(i, 1);
      console.log(this.puntosCliente)
      console.log(this.marcadores)
    }
  }

  moverMarker(i, punto , evento) {
    punto.latitud=evento.coords.lat
    punto.longitud=evento.coords.lng

    console.log(evento)
    console.log(i)
    console.log(this.marcadores)
    console.log(this.puntosCliente)

    this.marcadores.forEach((element,indice) => {
        console.log(element, indice)
        if (i===indice) {
          element.lat = evento.coords.lat
          element.lng = evento.coords.lng
        }
    });

    console.log(this.marcadores)
  }


  clickedMarker(i, punto: Object) {
    console.log(this.puntosCliente)

    this.g.isOpen = false
    //En el caso de geocerca si marcadores es superior se ejecuta esto.
    if (this.marcadores.length > 1) {
      this.paths.push([...this.marcadores]);
      this.marcadores = [];
      this.puntosCliente = [];
      //zoneInfo.open();
      console.log(this.paths);
    }

  }

  /**
   * POLYGON
   */
    EliminarGeocerca(i, poly){
      console.log(i, poly)
      if (poly.cod_geocerca) {
        console.log('Aca no sucedio nada')
      }else{
        console.log(i)
        this.paths.splice(i, 1); // eliminamos la geocerca con el indice que le corresponde
        console.log(this.paths)
        //this.paths = []
      }
    }

    registrarGeocerca(ev, g){

      this.g.lat = ev.latLng.lat();
      this.g.lng = ev.latLng.lng();
      this.g.cod_geocerca = null;
      this.g.des_geocerca = '';
      //this.g.puntos = this.paths
      this.g.puntos = this.paths[0] //como solo necesitamos 1 geocerca entramos en el cero


      this.g.isOpen = true;
      console.log(this.paths[0])


    }

    redimencionarGeocerca(i, ev){
      //REDIMENCIONAMOS LA GEOCERCA ACTUALIZANDO SUS VALORES
      // this.paths = [] //vaciamos

      this.paths.splice(i, 1);
      this.paths.push(...ev.newArr);//insertamos el nuevo arreglo

      //console.log(i)
      console.log(ev.newArr)
      //console.log(this.paths)

    }

    moverGeocerca(ev){
      console.log(ev)
    }

    infoWindowPolygon(polygon, data){
      this.g.isOpen = true;
      this.g.lat = polygon.latLng.lat();
      this.g.lng = polygon.latLng.lng();
      this.g.cod_geocerca = data.cod_geocerca;
      this.g.des_geocerca = data.des_geocerca;
      this.g.puntos = data.puntos
    }

    closeInfoWindowgeo(){
      this.g.isOpen = false;
      this.g.puntos = null
      //console.log(this.g)
    }
  /**
   * CIRCLE
   */
    cambioRadio(ev){
    }

    dragRadio(ev){
    }

  /**
   * Escucha para cambios en el tipo de mapa
   */
  listenForMapType() {
    this.MapToolsService.getMapTypeObs().subscribe(tipo => {
      this.currentMapType = tipo;
      this.mapConfig.mapType = tipo;
      if (this.map) {
        this.map.setMapTypeId(tipo);
      }
    });
  }

  /**
   * Escucha para activar/desactivar el mapa de calor
   */
  listenForHeatmap() {
    this.MapToolsService.getHeatmapObs().subscribe(visible => {
      this.heatmapVisible = visible;

      if (visible) {
        this.crearMapaCalor();
      } else {
        this.eliminarMapaCalor();
      }
    });
  }

  /**
   * Escucha para activar/desactivar la visualización del terreno
   */
  listenForTerrain() {
    this.MapToolsService.getTerrainObs().subscribe(visible => {
      this.terrainVisible = visible;

      if (visible) {
        if (this.map) {
          // Activar capa de elevación/terreno
          this.map.setOptions({
            mapTypeId: 'terrain'
          });
        }
      } else {
        if (this.map) {
          // Restaurar el tipo de mapa anterior
          this.map.setMapTypeId(this.currentMapType);
        }
      }
    });
  }

  /**
   * Escucha para activar/desactivar la herramienta de medición de distancia
   */
  listenForMedicionDistancia() {
    this.MapToolsService.getMedicionDistanciaObs().subscribe(active => {
      this.medicionDistanciaActiva = active;

      if (active) {
        // Limpiar puntos de medición previos
        this.puntosMedicion = [];
        this.distanciaMedida = 0;
        // Activar modo de click en mapa para medición
        this.canClickMap = true;
      } else {
        // Desactivar modo de click en mapa
        this.canClickMap = false;
        // Limpiar líneas de medición
        this.puntosMedicion = [];
      }
    });
  }

  /**
   * Escucha para activar/desactivar la herramienta de cálculo de áreas
   */
  listenForMedicionArea() {
    this.MapToolsService.getMedicionAreaObs().subscribe(active => {
      this.medicionAreaActiva = active;

      if (active) {
        // Limpiar puntos de medición previos
        this.puntosMedicion = [];
        this.areaMedida = 0;
        this.poligonoEditable = true;
        // Activar modo de click en mapa para medición
        this.canClickMap = true;

        // Si hay un polígono nativo, eliminarlo al cambiar de modo
        if (this.poligonoGoogleMaps) {
          this.poligonoGoogleMaps.setMap(null);
          this.poligonoGoogleMaps = null;
        }
      } else {
        // Desactivar modo de click en mapa
        this.canClickMap = false;
        // Limpiar polígono de medición
        this.puntosMedicion = [];

        // Eliminar polígono nativo si existe
        if (this.poligonoGoogleMaps) {
          this.poligonoGoogleMaps.setMap(null);
          this.poligonoGoogleMaps = null;
        }
      }
    });
  }

  /**
   * Crea el mapa de calor con los datos de vehículos
   */
  crearMapaCalor() {
    if (google && google.maps && this.map) {
      // Preparar datos para el mapa de calor usando los marcadores existentes
      const heatmapData = this.markers.map(punto => {
        return new google.maps.LatLng(punto.latitud, punto.longitud);
      });

      this.heatmapData = heatmapData;

      // Crear la capa de mapa de calor
      const heatmap = new google.maps.visualization.HeatmapLayer({
        data: heatmapData,
        map: this.map,
        radius: 20,
        opacity: 0.7
      });

      // Guardar referencia a la capa del mapa de calor
      this.mapConfig.heatmapLayer = heatmap;
    }
  }

  /**
   * Elimina el mapa de calor
   */
  eliminarMapaCalor() {
    if (this.mapConfig.heatmapLayer) {
      this.mapConfig.heatmapLayer.setMap(null);
      this.mapConfig.heatmapLayer = null;
    }
  }

  /**
   * Calcula la distancia entre dos puntos en metros
   */
  calcularDistancia(lat1, lng1, lat2, lng2) {
    if (google && google.maps) {
      const p1 = new google.maps.LatLng(lat1, lng1);
      const p2 = new google.maps.LatLng(lat2, lng2);
      return google.maps.geometry.spherical.computeDistanceBetween(p1, p2);
    }
    return 0;
  }

  /**
   * Calcula el área de un polígono en metros cuadrados
   */
  calcularArea(puntos) {
    if (google && google.maps && puntos.length >= 3) {
      const paths = puntos.map(p => new google.maps.LatLng(p.lat, p.lng));
      return google.maps.geometry.spherical.computeArea(paths);
    }
    return 0;
  }

  /**
   * Cancela la medición actual (distancia o área)
   */
  cancelarMedicion() {
    if (this.medicionDistanciaActiva) {
      this.medicionDistanciaActiva = false;
      this.MapToolsService.medicionDistancia = false;
      this.MapToolsService.setMedicionDistanciaObs(false);
    }

    if (this.medicionAreaActiva) {
      this.medicionAreaActiva = false;
      this.MapToolsService.medicionArea = false;
      this.MapToolsService.setMedicionAreaObs(false);
    }

    // Limpiar datos de medición
    this.limpiarMedicion();
  }

  /**
   * Limpiar los datos de medición
   */
  limpiarMedicion() {
    this.puntosMedicion = [];
    this.distanciaMedida = 0;
    this.areaMedida = 0;

    // Eliminar el polígono nativo si existe
    if (this.poligonoGoogleMaps) {
      this.poligonoGoogleMaps.setMap(null);
      this.poligonoGoogleMaps = null;
    }
  }

  /**
   * Cierra el polígono uniendo el último punto con el primero
   */
  cerrarPoligono() {
    if (this.puntosMedicion.length >= 3) {
      // Verificar si ya está cerrado (último punto igual al primero)
      const primerPunto = this.puntosMedicion[0];
      const ultimoPunto = this.puntosMedicion[this.puntosMedicion.length - 1];

      // Solo cerrar si no está ya cerrado
      if (primerPunto.lat !== ultimoPunto.lat || primerPunto.lng !== ultimoPunto.lng) {
        // Cerrar el polígono añadiendo una copia del primer punto al final
        this.puntosMedicion.push({...primerPunto});
      }

      // Recalcular el área
      this.areaMedida = this.calcularArea(this.puntosMedicion);

      // Crear polígono nativo para edición avanzada
      this.crearPoligonoAvanzado();
    }
  }

  /**
   * Crea un efecto visual de clic en las coordenadas proporcionadas
   */
  crearEfectoClick(lat, lng) {
    if (this.map) {
      // Obtener el punto del mapa en pixeles
      const overlay = new google.maps.OverlayView();
      overlay.draw = function() {};
      overlay.setMap(this.map);

      const point = overlay.getProjection().fromLatLngToContainerPixel(
        new google.maps.LatLng(lat, lng)
      );

      // Crear elemento visual
      const clickMarker = document.createElement('div');
      clickMarker.className = 'click-animation';
      clickMarker.style.left = (point.x - 10) + 'px';
      clickMarker.style.top = (point.y - 10) + 'px';

      // Añadir al DOM
      const mapContainer = document.querySelector('.agm-map');
      if (mapContainer) {
        mapContainer.appendChild(clickMarker);

        // Eliminar después de la animación
        setTimeout(() => {
          if (mapContainer.contains(clickMarker)) {
            mapContainer.removeChild(clickMarker);
          }
        }, 1000);
      }
    }
  }

  /**
   * Crea un polígono de Google Maps nativo y configura listeners avanzados
   */
  crearPoligonoAvanzado() {
    // Si ya existe un polígono, eliminarlo primero
    if (this.poligonoGoogleMaps) {
      this.poligonoGoogleMaps.setMap(null);
      this.poligonoGoogleMaps = null;
    }

    // Verificar que tenemos suficientes puntos y un mapa válido
    if (!this.map || this.puntosMedicion.length < 3) {
      return;
    }

    console.log("Creando polígono nativo con puntos:", this.puntosMedicion);

    // Convertir nuestros puntos al formato esperado por Google Maps
    const paths = this.puntosMedicion.map(p => new google.maps.LatLng(p.lat, p.lng));

    // Crear el polígono directamente con la API de Google Maps
    this.poligonoGoogleMaps = new google.maps.Polygon({
      paths: paths,
      strokeColor: '#0000FF',
      strokeOpacity: 0.8,
      strokeWeight: 2,
      fillColor: '#0000FF',
      fillOpacity: 0.35,
      editable: true,
      draggable: true,
      map: this.map
    });

    // Añadir listeners para todos los eventos de edición posibles
    google.maps.event.addListener(this.poligonoGoogleMaps, 'mouseup', this.actualizarDesdePoligonoNativo.bind(this));
    google.maps.event.addListener(this.poligonoGoogleMaps, 'dragend', this.actualizarDesdePoligonoNativo.bind(this));
    google.maps.event.addListener(this.poligonoGoogleMaps.getPath(), 'set_at', this.actualizarDesdePoligonoNativo.bind(this));
    google.maps.event.addListener(this.poligonoGoogleMaps.getPath(), 'insert_at', this.actualizarDesdePoligonoNativo.bind(this));
    google.maps.event.addListener(this.poligonoGoogleMaps.getPath(), 'remove_at', this.actualizarDesdePoligonoNativo.bind(this));

    console.log("Polígono nativo creado y listeners configurados");
  }

  /**
   * Actualiza los puntos y el área desde el polígono nativo de Google Maps
   */
  actualizarDesdePoligonoNativo() {
    if (!this.poligonoGoogleMaps) {
      return;
    }

    try {
      // Obtener los puntos actuales del polígono
      const path = this.poligonoGoogleMaps.getPath();
      const puntos = [];

      for (let i = 0; i < path.getLength(); i++) {
        const punto = path.getAt(i);
        puntos.push({
          lat: punto.lat(),
          lng: punto.lng()
        });
      }

      console.log("Puntos actualizados desde polígono nativo:", puntos);

      // Actualizar nuestros puntos
      this.puntosMedicion = puntos;

      // Calcular el área utilizando la API de Google Maps directamente
      const areaEnMetrosCuadrados = google.maps.geometry.spherical.computeArea(path);
      console.log("Área calculada directamente:", areaEnMetrosCuadrados.toFixed(2) + " m²");

      // Actualizar nuestra propiedad
      this.areaMedida = areaEnMetrosCuadrados;
      this.ultimaAreaCalculada = areaEnMetrosCuadrados;

      // Forzar actualización de la vista
      setTimeout(() => {
        // Este timeout vacío ayuda a forzar la actualización de Angular
      }, 0);
    } catch (error) {
      console.error("Error al actualizar desde polígono nativo:", error);
    }
  }

  /**
   * Detecta cuando el mapa está listo y configura eventos adicionales
   * @param mapInstance Instancia del mapa de Google Maps
   */
  setInstance(mapInstance) {
    this.map = mapInstance;
    this.trafficLayer = new google.maps.TrafficLayer();

    // IMPORTANTE: Guardar referencia del mapa en el servicio para que el buscador pueda acceder
    console.log('🗺️ Guardando referencia del mapa en MapToolsService...');
    this.MapToolsService.setMapa(mapInstance);
    console.log('✅ Referencia del mapa guardada correctamente');

    // Configurar opciones de control de tipo de mapa
    this.map.setOptions({
      mapTypeControlOptions: {
        position: google.maps.ControlPosition.TOP_CENTER,
        style: google.maps.MapTypeControlStyle.HORIZONTAL_BAR,
        mapTypeIds: [
          google.maps.MapTypeId.ROADMAP,
          google.maps.MapTypeId.SATELLITE,
          google.maps.MapTypeId.HYBRID,
          google.maps.MapTypeId.TERRAIN
        ]
      },
      fullscreenControlOptions: {
        position: google.maps.ControlPosition.RIGHT_TOP
      }
    });

    // Log para verificar que el mapa se inició correctamente
    //console.log('Mapa inicializado:', this.map);
  }

  /**
   * Actualiza el cálculo del área sin mostrar mensaje
   */
  actualizarCalculoAreaSinMensaje() {
    if (this.medicionAreaActiva && this.puntosMedicion.length >= 3) {
      // Si tenemos un polígono nativo, obtener los datos de allí
      if (this.poligonoGoogleMaps) {
        this.actualizarDesdePoligonoNativo();
      } else {
        // Fallback al cálculo basado en los puntos actuales
        const nuevaArea = this.calcularArea(this.puntosMedicion);

        console.log('Área calculada: ' + nuevaArea.toFixed(2) + ' m²');
        this.areaMedida = nuevaArea;
        this.ultimaAreaCalculada = this.areaMedida;
      }
    }
  }

  /**
   * Guarda la referencia al objeto polígono de Google Maps
   * @param polygon Objeto polígono de Google Maps
   */
  onPolygonReady(polygon) {
    this.poligonoActual = polygon;
    console.log('Polígono listo:', polygon);
  }

  /**
   * Finaliza la edición del polígono, manteniendo la forma actual
   */
  finalizarEdicion() {
    this.poligonoEditable = false;

    // Si existe un polígono nativo, actualizarlo
    if (this.poligonoGoogleMaps) {
      this.poligonoGoogleMaps.setEditable(false);
      this.poligonoGoogleMaps.setDraggable(false);
    }
  }

  /**
   * Reactiva la edición del polígono
   */
  reactivarEdicion() {
    this.poligonoEditable = true;

    // Si existe un polígono nativo, actualizarlo
    if (this.poligonoGoogleMaps) {
      this.poligonoGoogleMaps.setEditable(true);
      this.poligonoGoogleMaps.setDraggable(true);
    }
  }

  /**
   * Inicia un monitoreo constante de los cambios en el polígono
   */
  iniciarMonitoreoPoligono() {
    // Detener monitoreo existente si hay alguno
    this.detenerMonitoreoPoligono();

    // Iniciar nuevo monitoreo
    this.intervaloActualizacionPoligono = setInterval(() => {
      if (this.medicionAreaActiva && this.poligonoActual && this.puntosMedicion.length >= 3) {
        this.obtenerPuntosDelPoligono();
      }
    }, 500); // Verificar cada 500ms
  }

  /**
   * Detiene el monitoreo de cambios en el polígono
   */
  detenerMonitoreoPoligono() {
    if (this.intervaloActualizacionPoligono) {
      clearInterval(this.intervaloActualizacionPoligono);
      this.intervaloActualizacionPoligono = null;
    }
  }

  /**
   * Obtiene los puntos actuales del polígono y actualiza el cálculo del área
   */
  obtenerPuntosDelPoligono() {
    try {
      if (this.poligonoActual && this.poligonoActual.getPaths) {
        const paths = this.poligonoActual.getPaths();
        const puntos = [];

        // Extraer coordenadas del primer path
        if (paths && paths.getAt && paths.getLength() > 0) {
          const path = paths.getAt(0);
          for (let i = 0; i < path.getLength(); i++) {
            const punto = path.getAt(i);
            if (punto && typeof punto.lat === 'function' && typeof punto.lng === 'function') {
              puntos.push({
                lat: punto.lat(),
                lng: punto.lng()
              });
            }
          }

          if (puntos.length > 2) {
            // Verificar si los puntos son diferentes a los que ya tenemos
            let puntosModificados = false;

            if (puntos.length !== this.puntosMedicion.length) {
              puntosModificados = true;
            } else {
              // Comprobar si algún punto ha cambiado
              for (let i = 0; i < puntos.length; i++) {
                if (puntos[i].lat !== this.puntosMedicion[i].lat ||
                    puntos[i].lng !== this.puntosMedicion[i].lng) {
                  puntosModificados = true;
                  break;
                }
              }
            }

            if (puntosModificados) {
              console.log('Puntos modificados, actualizando área...');
              this.puntosMedicion = [...puntos];
              this.actualizarCalculoAreaSinMensaje();
            }
          }
        }
      }
    } catch (error) {
      console.error('Error al obtener puntos del polígono:', error);
    }
  }

  /**
   * Maneja el evento de cambio en el polígono para recalcular el área
   * @param event Evento con los nuevos puntos del polígono
   */
  onPolygonPathsChange(event) {
    if (this.medicionAreaActiva && this.puntosMedicion.length >= 3) {
      try {
        // El evento es solo un disparador, vamos a obtener los puntos actualizados
        this.obtenerPuntosDelPoligono();
      } catch (error) {
        console.error('Error al procesar el cambio del polígono:', error);
      }
    }
  }

  /**
   * Fuerza la actualización del cálculo del área manualmente
   */
  actualizarCalculoArea() {
    // Si tenemos un polígono nativo, obtener los datos actualizados
    if (this.poligonoGoogleMaps) {
      this.actualizarDesdePoligonoNativo();
    } else {
      // Obtener los puntos actuales directamente
      this.obtenerPuntosDelPoligono();
    }

    if (this.medicionAreaActiva && this.puntosMedicion.length >= 3) {
      // Mostrar un mensaje con el área actualizada
      Swal.fire({
        title: 'Cálculo actualizado',
        text: 'Área: ' + this.areaMedida.toFixed(2) + ' m² / ' + (this.areaMedida / 10000).toFixed(2) + ' ha / ' + (this.areaMedida / 1000000).toFixed(2) + ' km²',
        icon: 'success',
        timer: 2000,
        showConfirmButton: false
      });
    }
  }

  /**
   * Escucha para activar/desactivar la selección de rutas en el mapa
   */
  listenForSeleccionRutas() {
    this.MapToolsService.getSeleccionRutasActivaObs().subscribe(active => {
      this.seleccionRutasActiva = active;

      if (active) {
        // Activar modo de click en mapa para selección de rutas
        this.canClickMap = true;
      } else {
        // Desactivar modo de click en mapa si no hay otros modos activos
        if (!this.medicionDistanciaActiva && !this.medicionAreaActiva) {
          this.canClickMap = false;
        }
      }
    });
  }

  /**
   * Escucha los puntos temporales para mostrar durante la selección de rutas
   */
  listenForPuntosTemporalesRuta() {
    this.MapToolsService.getPuntosTemporalesRutaObs().subscribe(puntos => {
      console.log('🗺️ MAPA: Recibidos puntos temporales:', puntos);
      this.puntosTemporalesRuta = puntos;
    });
  }

  /**
   * Configura la posición y estilo de los controles del mapa
   */
  configurarControlesMapa() {
    if (this.map) {
      // Configurar la posición del control de tipo de mapa (satélite, etc.)
      this.map.setOptions({
        mapTypeControlOptions: {
          position: google.maps.ControlPosition.TOP_CENTER,
          style: google.maps.MapTypeControlStyle.HORIZONTAL_BAR
        }
      });

      console.log('Controles del mapa posicionados al centro');
    }
  }
}
